import React from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'

function Shippingdetails(props: any) {
    console.log(props)
    return (
        <div className="modal fade com-modal short-modal checkout-modal show" id="checkoutModal" aria-labelledby="checkoutModalLabel" aria-hidden="true" style={{ display: "block" }} >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="checkoutModalLabel">{LanguageConstants?.SHPPING_DEATILS}</h5>
                        <button onClick={() => props?.setShow(false)} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                    </div>
                    <div className="modal-body pb-0 text-start">
                        <div className="id-mob">
                            <div className="">
                                <span className="id-mob-label">{LanguageConstants?.TRAKING_URL} :</span>
                                {props?.data?.tracking_url ? (
                                    <a href={props?.data?.tracking_url} target="_blank" rel="noopener noreferrer">
                                        {props?.data?.tracking_url}
                                    </a>
                                ) : (
                                    "No URL available"
                                )}
                            </div>

                            {/* <div className=""><span className="id-mob-label">Tracking Url :</span>  {props?.data?.tracking_url}</div> */}
                            {props?.data?.tracking_number ? 
                            <div className=""><span className="id-mob-label">{LanguageConstants?.TRAKING_NUMBER} :</span> {props?.data?.tracking_number}</div> 
                            : null}
                            <div className=""><span className="id-mob-label">{LanguageConstants?.SHIPPINSCompany} :</span> {props?.data?.shipping_company}</div>
                            {props?.data?.waybill_number ? 
                            <div className=""><span className="id-mob-label">{LanguageConstants?.WAYBILLNUMBER} :</span> {props?.data?.waybill_number}</div>
                            :null}
                            {props?.data?.awb_number ? 
                            <div className=""><span className="id-mob-label">{LanguageConstants?.AWB_NUMBER} :</span> {props?.data?.awb_number}</div>
                            :null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Shippingdetails